import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import PageHeading from '../../components/Organisms/PageHeading';
import useTranslate from '../../hooks/useTranslate';

const ExpertsPage = () => {
  const [createToggle, setCreateToggle] = useState(false);
  const [searchDataLoading, setSearchDataLoading] = useState(true);
  const [searchData, setSearchData] = useState([]);
  const navigate = useNavigate();
  const t = useTranslate();

  return (
    <div className="w-full">
      <PageHeading
        userRole={3}
        title={t('experts')}
        addButtonName={`+ ${t('add')} ${t('expert')}`}
        hasSearch
        buttonClick={() => {
          setCreateToggle(true);
          navigate('/d/experts/add');
        }}
        setSearchData={setSearchData}
        setSearchDataLoading={setSearchDataLoading}
      />
      <Outlet
        context={[createToggle, setCreateToggle, searchData, searchDataLoading]}
      />
    </div>
  );
};

export default ExpertsPage;
